import LowerCode from '../../views/LowerCode'

LowerCode.install = function (Vue) {
    Vue.component(LowerCode.name, LowerCode)
}

export default LowerCode
